// phone view search icon 
document.addEventListener("DOMContentLoaded", function () {
    const searchDetails = document.querySelector("#phone-header-search");
  // console.log("isssue found")
    console.log("dddd",searchDetails)
    if (searchDetails) {
      if (window.innerWidth <= 768) {
        searchDetails.removeAttribute("open"); 
        // console.log("sixe confirm")
      }else{
        // console.log("desktop width")
      }
    }
  })


// end


let words = ["PCOS Capsules", "Female Fertility", "Period Pain Relief" , "Anti-Acne"];
let wordIndex = 0;
let charIndex = 0;
let staticText = "Search for "; 

function typeText() {
    const currentWord = words[wordIndex];
    if (charIndex < currentWord.length) {
        document.getElementById("fname").innerHTML = staticText + currentWord.substring(0, charIndex + 1);
        charIndex++;
        setTimeout(typeText, 150); // Adjust speed of typing
    } else {
        setTimeout(eraseText, 1000); // Pause before starting erase
    }
}

function eraseText() {
    const currentWord = words[wordIndex];
    if (charIndex > 0) {
        document.getElementById("fname").innerHTML = staticText + currentWord.substring(0, charIndex - 1);
        charIndex--;
        setTimeout(eraseText, 100); // Adjust speed of erasing
    } else {
        wordIndex = (wordIndex + 1) % words.length; // Move to the next word
        setTimeout(typeText, 500); // Pause before typing the next word
    }
}

// To start the animation, call typeText
typeText();




